<script lang="ts" setup>
const props = defineProps<{ data: OpeningHour[] }>()

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

function formatTime(time) {
  const [hour, minute] = time.split(':')
  const hourNumber = Number.parseInt(hour, 10)
  const period = hourNumber >= 12 ? 'pm' : 'am'
  const formattedHour = hourNumber % 12 || 12
  return `${formattedHour}:${minute}${period}`
}

function getTimeDisplay(start: string, end: string) {
  if (start === end) {
    return 'Closed'
  }
  return `${formatTime(start)} - ${formatTime(end)}`
}

const { isOpenNow } = useBusinessHours(props.data)
</script>

<template>
  <div v-if="data?.length" class="bg-darkblue rounded-2xl lg:rounded-3xl p-12 max-w-7xl mx-auto text-white flex flex-wrap justify-between items-center gap-6">
    <CollectionBusinessOnlineIndicator :visible="isOpenNow" size="2xl" :ui="{ wrapper: 'w-full md:w-auto justify-start' }">
      <HeadingText tag="h2" class="text-yellow">
        Opening Hours
      </HeadingText>
    </CollectionBusinessOnlineIndicator>
    <ul class="text-lg md:text-xl lg:text-2xl w-full xl:w-auto gap-3">
      <li v-for="day in data" :key="day.id" class="flex flex-wrap justify-between w-full gap-x-6">
        {{ DAYS[day.day - 1] }} <span class="ml-auto">{{ getTimeDisplay(day.start, day.end) }}</span>
      </li>
    </ul>
  </div>
</template>

<style lang="postcss" scoped>

</style>
